// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .fxHwDJIEFk8oofOGTT_d a {
    color: var(--primary-link-color);
    text-decoration: unset
  }
.fxHwDJIEFk8oofOGTT_d a:hover {
      text-decoration: underline;
    }
`, "",{"version":3,"sources":["webpack://./src/components/DangerouslySetInnerHtml/DangerouslySetInnerHtml.module.css"],"names":[],"mappings":";EACE;IACE,gCAAgC;IAChC;EAKF;AAHE;MACE,0BAA0B;IAC5B","sourcesContent":[".dangerouslySetInnerHtml {\n  & :global a {\n    color: var(--primary-link-color);\n    text-decoration: unset;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dangerouslySetInnerHtml": `fxHwDJIEFk8oofOGTT_d`
};
export default ___CSS_LOADER_EXPORT___;
